//react imports
import injectSheet from "react-jss";
import React from "react";
import {useDispatch, useSelector} from "react-redux";

// material
import {Group} from "@insticator/insticator-ui";

//redux imports
import {updateReportForm} from "../../../../state/slices/report";

// components
import DeviceFilter from "../../reportbuilder/monetizationform/filter/devices/devices";
import CountryFilter from "../../reportbuilder/monetizationform/filter/countries/countries";
import SiteFilter from "../../reportbuilder/monetizationform/filter/sites/sites";
import SectionGroup from "../../../../material/expandablesection/sectiongroup/sectiongroup";

// statics
import {FILTERS, REPORT_NAME} from "../../reportbuilder/monetizationform/consts";

//styles
import styles from './filters_styles';

/* ========== ~~~~~~~~~~ METRICS FILTER FORM ~~~~~~~~~~ ========== */
export default injectSheet(styles)((props) => {

    const formValues = useSelector((state) => state.report[props.uuid]);
    const dispatch = useDispatch();

    const handleOnChange = newValues => {
        dispatch(updateReportForm({...formValues, ...newValues}));
    }
    return (
        <SectionGroup row>
            <Group>
                <label className={props.classes.filterLabel}>Filters</label>
                <div className={props.classes.filter}>
                    <SiteFilter handleOnChange={handleOnChange} filterValues={formValues[FILTERS]} />
                    <DeviceFilter handleOnChange={handleOnChange} filterValues={formValues[FILTERS]} />
                    <CountryFilter handleOnChange={handleOnChange} filterValues={formValues[FILTERS]} />
                </div>
            </Group>
        </SectionGroup>
    )
});
